"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSRLModules = exports.SRLModulesEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var SRLModulesEventType;
(function (SRLModulesEventType) {
    SRLModulesEventType["EDIT_SEARCH"] = "\uD83D\uDE80 srl.currentsearch.edit";
    SRLModulesEventType["RESET_SEARCH"] = "\uD83D\uDE80 srl.currentsearch.reset";
    SRLModulesEventType["SELECT_SUB_GEO_FILTER"] = "\uD83D\uDE80 srl.subgeofilter.select";
    SRLModulesEventType["CHANGE_SORT"] = "\uD83D\uDE80 srl.sort.change";
    SRLModulesEventType["OPEN_MAP"] = "\uD83D\uDE80 srl.map.open";
    SRLModulesEventType["OPEN_FILTER"] = "\uD83D\uDE80 srl.filter.open";
})(SRLModulesEventType || (exports.SRLModulesEventType = SRLModulesEventType = {}));
const trackSRLModules = (action) => {
    let eventMetadata = {};
    switch (action.type) {
        case SRLModulesEventType.SELECT_SUB_GEO_FILTER:
        case SRLModulesEventType.CHANGE_SORT:
            eventMetadata = action.payload;
            break;
    }
    (0, libs_tracking_events_1.track)({
        event: action.type,
        eventMetadata: eventMetadata,
        _clear: true,
    });
};
exports.trackSRLModules = trackSRLModules;
//# sourceMappingURL=trackSRLModules.js.map